import * as React from 'react';
import ReactGA from 'react-ga';
import styled,  { keyframes }from "styled-components";
import loading from "../Img/loading@3x.png";

const Loading = () => {
    return (
        <Layer>
            <Contents>
                <TextWrap>
                    <img src={loading} alt="loading"/>
                    <Title>찐본캐 분석 중</Title>
                </TextWrap>
            </Contents>
        </Layer>
    );
};

export default Loading;

const Layer = styled.div`
            position: absolute;
            text-align: center;
            width: 100%;
            top: 150px;
             @media only screen and (min-width: 768px) {
                top: 150px;
                left: 0;
  }
`
const Contents = styled.div `
    height: 100%;
    margin: 0 auto 0 auto;
    display: inline-block;
            vertical-align: middle
`
const rotate = keyframes`
    0% {margin-top: -10px;}
    100% {margin-top: 0px;}
`
const TextWrap = styled.div `
    margin: 0 0 0 0;
    float: left;
    width: 375px;
    height: 100%;
    img {
        width: 315px;
        height: 200px;
        animation:  ${rotate} 0.3s linear 0s infinite alternate;
    }
`

const Title = styled.label `
      float: left;
      width: 100%;
      font-family: GmarketSansTTFBold;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      padding-top: 30px;
`